module.exports = __webpack_public_path__ + "img/unit-card-battery.c1c4e1f0.png";